import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModuleByRoleDTO } from 'src/app/models/ModuleByRoleDTO.model';
import { RoleDTO } from 'src/app/models/RoleDTO.model';
import { RoleService } from 'src/app/services/role.service';
import { Alert } from 'src/app/shared/models/Alert';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-view-role',
    templateUrl: './view-role.component.html',
    styleUrl: './view-role.component.css',
    imports: [CommonModule, FormsModule]
})
export class ViewRoleComponent {
  title: string = 'Information Role';
  fieldsCompleted: boolean = false;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]),
  });

  get emailModel() {
    return this.form.get('email');
  }

  information: string = 'Information';
  roleName: string = '';
  requestRole: SimpleRequestDTO = {} as SimpleRequestDTO;

  alert: Alert = {} as Alert;
  role: RoleDTO = {} as RoleDTO;
  isActive: boolean = false;

  listModuleByRole: ModuleByRoleDTO[] = [];
  currentPage: number = 1;
  totalPages: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'NameModule'
  ];
  isFilteredByStatus: boolean = false;
  originalModuleByRoles: ModuleByRoleDTO[] = [];
  recordsPerPage: number = 10;

  constructor(
    private roleService: RoleService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
      this.route.params.subscribe((params) => {
     // console.log(params['id']);
      this.information = 'Role ID ' + params['id'];
      this.requestRole.id = params['id'];
      this.roleService.getRoleById(this.requestRole).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleGetRoleByIdSuccess(Data)
            : this.handleSaveError(StatusCode),
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
          this.clearFields();
          this.clearFields();
        }
      );

      this.roleService.getModuleByRole(this.requestRole).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleGetListRoles(Data);
          } else {
            this.HandleGetListCustomersError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
        }
      );
    });

    this.permissionsService.validateAccessLevels(MODULE_ID.RoleManagement);
  }

  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListRoles(roleDto: ModuleByRoleDTO[]) {
    //console.log(roleDto);
    this.listModuleByRole = roleDto;

    this.originalModuleByRoles = this.listModuleByRole.slice();
    // this.listModuleByRole = this.originalModuleByRoles.filter(
    //   (moduleRole) => moduleRole.sta === 0 || moduleRole.aRoleStatus === 1
    // );
    this.totalPages = Math.ceil(this.listModuleByRole.length / this.recordsPerPage);
  }

  handleGetRoleByIdSuccess(role: RoleDTO) {
    this.role.aRoleName = role.aRoleName ?? 0;
    this.role.aRoleStatus = role.aRoleStatus ?? 0;

    this.roleName = this.role.aRoleName;
    this.isActive = role.aRoleStatus === 1;
    this.checkFields();
  }

  clearFields() {
    this.roleName = '';
  }

  updateRole() {
    this.role.aRoleId = this.requestRole.id ?? 0;
    this.role.aRoleName = this.roleName;
    this.role.aRoleStatus = this.isActive ? 1 : 0;

    this.roleService.updateRole(this.role).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleUpdateSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (
      this.roleName
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  goBack() {
    window.location.href = '/role-management';
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  async handleUpdateSuccess(user: boolean) {
    if (user === false) {
      this.alert = {
        alertMessage: 'Unexpected error. Please try again later.',
        alertType: 'alert alert-danger',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      this.alertService.updateAlertState(
        this.alert
      );
    } else {
      this.alert = {
        alertMessage: 'Role updated successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);

      this.clearFields();
      location.reload();
    }
  }

  updatePagination(): void {
    const filteredList = this.listModuleByRole.filter((customer: ModuleByRoleDTO) =>
      this.camposBusqueda.some((campo: string) =>
        (customer as any)[campo]
          .toString()
          .toLowerCase()
          .includes(this.textoBusqueda.toLowerCase())
      )
    );

    this.currentPage = 1;
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
  }

  onSearchChange(): void {
    this.updatePagination();
  }

  updatePermissions(){
    this.roleService.updateModuleByRole(this.listModuleByRole).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleUpdateModuleByRole(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
        this.clearFields();
      }
    );
  }

  handleUpdateModuleByRole(data: boolean){
    if (data === false) {
      this.alert = {
        alertMessage: 'Unexpected error. Please try again later.',
        alertType: 'alert alert-danger',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      this.alertService.updateAlertState(
        this.alert
      );
    } else {
      this.alert = {
        alertMessage: 'Permissions updated successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);

      this.clearFields();
      location.reload();
    }
  }
}
